import { render, staticRenderFns } from "./SubscribersCard.vue?vue&type=template&id=7221bf63&scoped=true"
import script from "./SubscribersCard.vue?vue&type=script&lang=js"
export * from "./SubscribersCard.vue?vue&type=script&lang=js"
import style0 from "./SubscribersCard.vue?vue&type=style&index=0&id=7221bf63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7221bf63",
  null
  
)

export default component.exports